import { useAuth0 } from "@auth0/auth0-vue";
import * as Sentry from "@sentry/vue";
import axios from "axios";
import { inject } from "vue";

import { useErrorsStore } from "@/stores/errors";

export default function useAxios() {

  const config = inject('config')
  const { getAccessTokenSilently } = useAuth0();
  const { pushError, pushErrorCode } = useErrorsStore();

  const instance = axios.create({
    baseURL: config.AOL_API_URL,
    //timeout: 2000
  });

  instance.interceptors.request.use(async (config) => {
    config.headers['Authorization'] = 'Bearer ' + await getAccessTokenSilently();
    return config;
  })

  instance.interceptors.response.use((response) => {
    return response;
  }, (error) => {
    if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED' || !error.response) {
      pushError({
        message: 'Errore di connessione al server',
        fatal: true
      });
      Sentry.captureException(error);
      return;
    }
    const status = error.response.status;
    if(status == 413) {
      pushErrorCode('entity-too-large', false);
      return Promise.reject(error);
    }
    const statusCategory = Math.floor(status / 100);
    if (statusCategory === 5) {
      pushErrorCode(error.response.data.code, true);
      Sentry.captureException(error);
      return;
    }
    if (statusCategory === 4) {
      if(error.response.data.code !== 'lot-code-exists') {
        pushErrorCode(error.response.data.code, false);
      }
      return Promise.reject(error);
    }
  });

  return instance
}

